// extracted by mini-css-extract-plugin
export default {"wrapper":"PackModalContent_wrapper__H5Epy","price":"PackModalContent_price__nxoQl","toprow":"PackModalContent_toprow__UGeNR"};